import React, { useEffect, useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Navigate, useLocation } from 'react-router-dom'

import { RootState } from '~/xidrBiz/store/types'
import { resetRedirect, fetchAccounts } from '~/xidrBiz/store/route/actions'
import SSOManager from '~/managers/SSOManager'
import { ConfigManager } from '~/managers/ConfigManager'

const RouteHooks: React.FC = () => {
  const location = useLocation()
  const dispatch = useDispatch()
  const currentRedirect = useSelector((state: RootState) => state.route.currentRedirect)

  const whenSwitchRoute = useCallback(() => {
    window.scrollTo(0, 0)
    dispatch(resetRedirect())

    if (SSOManager.isLogined() && !ConfigManager.isXIDRSite()) {
      dispatch(fetchAccounts())
    }
  }, [dispatch])

  useEffect(() => {
    whenSwitchRoute()
  }, [location, whenSwitchRoute])

  if (currentRedirect === null) {
    return null
  }

  return <Navigate to={currentRedirect} replace />
}

export default RouteHooks
